
class NavbarController {
    constructor($rootScope, $location, AppConfiguration) {
        let conf = AppConfiguration();
        this.$rootScope = $rootScope;
        this.menu = conf.menu().children();
        this.appTitle = conf.title();
        this.path = '#' + $location.path();
    }

}

NavbarController.$inject= ['$rootScope', '$location', 'AppConfiguration'];

export {NavbarController};



// WEBPACK FOOTER //
// ./app/components/common/navbar/navbar.controller.js